/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const positionLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 9v6h14V9H4zm8-4.8H4v1.5h8V4.2zM4 19.8h8v-1.5H4v1.5z" />
	</SVG>
);

export default positionLeft;
